var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 17.999
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0.15)",
    d: "M9 18a9.01 9.01 0 01-9-9 9.01 9.01 0 019-9 9.009 9.009 0 019 9 9.009 9.009 0 01-9 9zm0-8.251l2.62 2.62a.527.527 0 00.375.156.53.53 0 00.375-.156.525.525 0 00.155-.375.521.521 0 00-.155-.372L9.748 9l2.622-2.62a.532.532 0 000-.749.529.529 0 00-.375-.155.526.526 0 00-.374.155l-2.62 2.62-2.621-2.62a.526.526 0 00-.375-.155.526.526 0 00-.375.155.532.532 0 000 .749L8.25 9l-2.62 2.62a.521.521 0 00-.155.372.525.525 0 00.155.375.526.526 0 00.375.155.526.526 0 00.375-.155L9 9.747z"
  })));
}
export default SvgCloseBtn;